<template>
  <div>
    <a-card v-if="selectEnable || allEnable" :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline" :form="form">
        <a-row :gutter="16">
          <a-col :span="6">
            <a-form-item label="企业名称">
              <a-input  v-model="queryParam.enterpriseName"/>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="安装类别">
              <!--<a-select  :allowClear="true" :options="installTypeMap" v-model="queryParam.installType"></a-select>-->
              <a-select  v-model="queryParam.installType" :allowClear="true">
                <a-select-option  v-for="type in installTypeMap" :title="type.label" :key="type.value">{{type.label}}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="6" :offset="6" style="text-align: right">
            <a-button type="primary" htmlType="submit" @click="$refs.table.refresh(true)">查询</a-button>
            <a-button style="margin-left: 8px" @click="resetDate">清空</a-button>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <s-table
      style="margin-top: 20px"
      size="default"
      ref="table"
      rowKey="enterpriseId"
      :loading="loading"
      :columns="columns"
      :data="loadData"
      bordered
    >
    </s-table>
  </a-card>
    <no-authority v-if="!selectEnable && !allEnable"></no-authority>
  </div>
</template>

<script>
import { STable } from '@/components'
import { enterpriseQuery } from '@/api/enterprise/enterprise'
import { getDictMap } from '../../utils/dict'
import { checkPermission } from '@/utils/permissions'
import NoAuthority from './NoAuthority'

export default {
  name: 'EnterpriseList',
  components: {
    STable,
    NoAuthority
  },
  data () {
    return {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      form: this.$form.createForm(this),
      mdl: {},
      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam: {},
      // 表头
      columns: [
        {
          title: '序号',
          width:60,
          dataIndex: 'rowNum',
          align:'center'
        },
        {
          title: '企业全称',
          dataIndex: 'enterpriseFullName',
          align:'center'
        },
        {
          title: '企业简称',
          dataIndex: 'enterpriseSimpleName',
          align:'center'
        },
        {
          title: '安装类别',
          dataIndex: 'installType'
        },
        {
          title: '市场负责人',
          dataIndex: 'marketPrincipal',
          align:'center'
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          align:'center'
        }
      ],
      data: [],
      loading: false,
      loadData: parameter => {
        return enterpriseQuery(Object.assign(parameter, this.queryParam))
      },
      installTypeMap: [],
      selectEnable: checkPermission('enterprise:query:list:owner'),
      allEnable: checkPermission('enterprise:query:list:all'),
    }
  },
  filters: {
  },
  async created () {
    console.log(this.selectEnable,this.allEnable)
    // document.body.addEventListener('keyup', e => {
    //   if (e.keyCode == 13) {
    //     this.$refs.table.refresh(true)
    //   }
    // })
    // 安装类别
    this.installTypeArr = await getDictMap('install_type')
    this.installTypeArr.forEach((value, key) => {
      this.installTypeMap.push({ value: key, label: value })
    })
  },
  methods: {
    resetDate(){
      this.queryParam={}
      this.$refs.table.refresh(true)
    },
    handleOk () {
      this.$refs.table.refresh(true)
    }
  },
  watch: {
    /*
      'selectedRows': function (selectedRows) {
        this.needTotalList = this.needTotalList.map(item => {
          return {
            ...item,
            total: selectedRows.reduce( (sum, val) => {
              return sum + val[item.dataIndex]
            }, 0)
          }
        })
      }
      */
  }
}
</script>
<style scoped>
  /deep/ .ant-table th { white-space: nowrap; }
  /deep/ .ant-table td { white-space: nowrap; padding: 4px 16px !important;}
  /deep/ .ant-table-content{
    width:50%
  }
</style>